(function () {
  var main = document.getElementById('hr-main-img');
  document.querySelectorAll('.hr-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (main) { main.src = t.dataset.src; main.removeAttribute('srcset'); }
      document.querySelectorAll('.hr-thumb').forEach(function (o) { o.classList.toggle('is-active', o === t); });
    });
  });

  var form = document.getElementById('hr-form');
  var wait = document.getElementById('hr-wait');
  var note = document.getElementById('hr-note');
  function pick(input) {
    document.querySelectorAll('.hr-opt').forEach(function (o) { o.classList.toggle('is-on', o.contains(input)); });
    var soon = input.dataset.soon === 'true';
    if (form) form.classList.toggle('is-off', soon);
    if (wait) wait.classList.toggle('is-on', soon);
    if (note) note.textContent = soon ? note.dataset.wait : note.dataset.buy;
    if (soon) {
      var tags = document.getElementById('hr-wait-tags');
      var btn = document.getElementById('hr-wait-btn');
      if (tags) tags.value = 'newsletter, lista-' + input.dataset.tag;
      if (btn && input.dataset.cta) btn.textContent = input.dataset.cta;
      return;
    }
    var id = document.getElementById('hr-variant');
    var p1 = document.getElementById('hr-price');
    var p2 = document.getElementById('hr-btn-price');
    if (id) id.value = input.value;
    if (p1) p1.textContent = input.dataset.price;
    if (p2) p2.textContent = input.dataset.price;
  }
  document.querySelectorAll('input[name="hr-bundle"]').forEach(function (i) {
    i.addEventListener('change', function () { pick(i); });
  });
  var first = document.querySelector('input[name="hr-bundle"]:checked');
  if (first && first.dataset.soon === 'true') pick(first);
  if (wait && wait.querySelector('.hr-ok')) {
    wait.classList.add('is-on');
    if (form) form.classList.add('is-off');
  }

  /* hr-scroll: "Kup teraz" przewija do przycisku zakupu, nie na górę sekcji */
  document.querySelectorAll('a[href$="#kup"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = form && !form.classList.contains('is-off') ? form : wait;
      if (!target || !target.scrollIntoView) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* hr-single: ebook kupuje się w 1 sztuce – usuń wcześniejsze egzemplarze z koszyka, dodaj jeden, idź do płatności */
  if (form && window.fetch && window.FormData) {
    form.addEventListener('submit', function (e) {
      if (form.dataset.busy) return;
      e.preventDefault();
      form.dataset.busy = '1';
      var data = new FormData(form);
      var variant = String(data.get('id'));
      data.delete('return_to');
      data.set('quantity', '1');
      var json = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {};
          cart.items.forEach(function (item) { if (String(item.variant_id) === variant) updates[item.key] = 0; });
          if (!Object.keys(updates).length) return null;
          json.body = JSON.stringify({ updates: updates });
          return fetch('/cart/update.js', json);
        })
        .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data }); })
        .then(function (r) {
          if (!r.ok) throw new Error('add');
          window.location.href = '/checkout';
        })
        .catch(function () { form.submit(); });
    });
  }

  if (form) {
    form.addEventListener('invalid', function (e) {
      var label = e.target.closest('.hr-consent');
      if (label) label.classList.add('is-err');
    }, true);
    form.addEventListener('change', function (e) {
      var label = e.target.closest('.hr-consent');
      if (label && e.target.checked) label.classList.remove('is-err');
    });
  }
})();
